import {
  CLIENT_CONSIGNEE_ID,
  PAGE_SIZE,
  SUCCESS_MESSAGES,
} from "utils/constants";
import {
  GetState,
  UserDataItem,
  UsersActions,
  UsersState,
  UserTabName,
} from "types";
import {
  AddUserManagementRequest,
  AddUserManagementResponse,
  DeleteUserAdminRequest,
  DeleteUserAdminResponse,
  ListUsersManagementRequest,
  ListUsersManagementResponse,
  PhoneNumber,
  UpdateUserManagementRequest,
  UpdateUserManagementResponse,
  UserUpdateItem,
  UserDataUpdate,
  GetUserManagementRequest,
  GetUserManagementResponse,
  DownloadFileRequest,
  DownloadFileResponse,
  ListUsersRiderManagementRequest,
  ListUsersRiderManagementResponse,
  UploadPhotoRequest,
  UploadPhotoResponse,
  Filter,
  GetUsersFeedbackStatsRequest,
  GetUsersFeedbackStatsResponse,
  GetRiderSummaryRequest,
  GetRiderSummaryResponse, UserListingFilter,
} from "protobuf/user_service_pb";
import {
  userManagementServiceClient,
  userAdminServiceClient,
  userStatsServiceClient,
  userServiceClient,
} from "utils/grpc-clients";
import { NullableClientOrgId } from "protobuf/client_service_pb";
import { Dispatch } from "react";
import { PageRequest, PageResponse } from "protobuf/page_pb";
import { apiResponse } from "./common-actions";
import {
  UserAdminServiceClient,
  UserManagementServiceClient,
  UserServiceClient,
} from "protobuf/User_serviceServiceClientPb";
import { getFullName } from "utils/helpers";
import { Filters } from "protobuf/filter_pb";
import { GetRiderScoreGroupsRequest, GetRiderScoreGroupsResponse, GetRiderScoreListByAvgScoreRequest, GetRiderScoreListByAvgScoreResponse, GetUserStatsRequest, GetUserStatsResponse } from "protobuf/user_stats_service_pb";
import dayjs from "dayjs";
import { UserStatsServiceClient } from "protobuf/User_stats_serviceServiceClientPb";

interface UserPayload {
  firstName: string;
  lastName: string;
  clientOrgId?: string;
  countryPrefix: string;
  number: string;
  email: string;
  password: string;
  type: number;
  documentId: string;
  nationalId: string;
  licenceNo: string;
  vehicleId: string[];
  document: Uint8Array | string;
  documentName: string;
  documentExt: string;
  organizationId:string;
}

export function setUserSearch(payload: UsersState["search"]): UsersActions {
  return {
    type: "SET_USER_SEARCH",
    payload,
  };
}

export function setBulkActionsUser(
  payload: UsersState["showbulkActionsUser"]
): UsersActions {
  return {
    type: "SET_USER_BULK_ACTIONS",
    payload,
  };
}
export function setSelectedUserRows(
  payload: UsersState["selectedUserRows"]
): UsersActions {
  return {
    type: "SET_USER_SELECTED_ROWS",
    payload,
  };
}

export function setSelectedUser(
  payload: UsersState["selectedUser"]
): UsersActions {
  return {
    type: "SET_SELECTED_USER",
    payload,
  };
}

export function setAllUser(payload: UsersState["allUsers"]): UsersActions {
  return {
    type: "SET_ALL_USERS",
    payload,
  };
}

export function setAllUsersSelectedPage(
  payload: UsersState["allUsersPage"]["selectedPage"]
): UsersActions {
  return {
    type: "SET_ALL_USERS_SELECTED_PAGE",
    payload,
  };
}

export function setAllUsersTotalPage(
  payload: PageResponse.AsObject
): UsersActions {
  return {
    type: "SET_ALL_USERS_TOTAL_PAGE",
    payload,
  };
}

export function setAdminUser(payload: UsersState["adminUsers"]): UsersActions {
  return {
    type: "SET_ADMIN_USERS",
    payload,
  };
}

export function setAdminUsersSelectedPage(
  payload: UsersState["adminUsersPage"]["selectedPage"]
): UsersActions {
  return {
    type: "SET_ADMIN_USERS_SELECTED_PAGE",
    payload,
  };
}

export function setAdminUsersTotalPage(
  payload: PageResponse.AsObject
): UsersActions {
  return {
    type: "SET_ADMIN_USERS_TOTAL_PAGE",
    payload,
  };
}

export function setRiderUser(payload: UsersState["riderUsers"]): UsersActions {
  return {
    type: "SET_RIDER_USERS",
    payload,
  };
}

export function setRiderUsersSelectedPage(
  payload: UsersState["riderUsersPage"]["selectedPage"]
): UsersActions {
  return {
    type: "SET_RIDER_USERS_SELECTED_PAGE",
    payload,
  };
}

export function setRiderUsersTotalPage(
  payload: PageResponse.AsObject
): UsersActions {
  return {
    type: "SET_RIDER_USERS_TOTAL_PAGE",
    payload,
  };
}

export function setMechanicUser(
  payload: UsersState["mechanicUsers"]
): UsersActions {
  return {
    type: "SET_MECHANIC_USERS",
    payload,
  };
}

export function setMechanicUsersSelectedPage(
  payload: UsersState["mechanicUsersPage"]["selectedPage"]
): UsersActions {
  return {
    type: "SET_MECHANIC_USERS_SELECTED_PAGE",
    payload,
  };
}

export function setMechanicUsersTotalPage(
  payload: PageResponse.AsObject
): UsersActions {
  return {
    type: "SET_MECHANIC_USERS_TOTAL_PAGE",
    payload,
  };
}

export function setSelectedTab(
  payload: UsersState["selectedTab"]
): UsersActions {
  return {
    type: "SET_SELECTED_TAB",
    payload,
  };
}

export function setDropdownUsers(
  payload: UsersState["dropdownUsers"]
): UsersActions {
  return {
    type: "SET_DROPDOWN_USERS",
    payload,
  };
}

export function setRiderStats(
  payload: UsersState["riderStats"]
): UsersActions {
  return {
    type: "SET_RIDER_STATS",
    payload,
  };
}

export function setFeedbackStats(
  payload: UsersState["feedbackStats"]
): UsersActions {
  return {
    type: "SET_FEEDBACK_STATS",
    payload,
  };
}

export function setRiderScoreGroups(
  payload: UsersState["riderScoreGroups"]
): UsersActions {
  return {
    type: "SET_RIDER_SCORE_GROUP",
    payload,
  };
}

export function setRiderSummary(
  payload: UsersState["riderList"]
): UsersActions {
  return {
    type: "SET_RIDER_SUMMARY",
    payload,
  };
}

export function setUsersEmpty(): UsersActions {
  console.log("reach user state")
  return {
    type: "SET_USERS_EMPTY",
    payload: undefined
  }
}

export function addUser({
  countryPrefix,
  email,
  firstName,
  lastName = "",
  number,
  password,
  type,
  documentId,
  nationalId,
  licenceNo,
  document,
  vehicleId,
  documentExt,
  documentName,
    organizationId,
}: UserPayload) {
  return (dispatch: Dispatch<any>, getState: GetState) => {
    const { selectedTab } = getState().users;

    const user = new UserUpdateItem();
    user.setFirstName(firstName);
    user.setLastName(lastName);

    const consignee = new NullableClientOrgId();
    consignee.setVal(CLIENT_CONSIGNEE_ID);

    const phone = new PhoneNumber();
    phone.setCountryPrefix(countryPrefix);
    phone.setNumber(number);

    const request = new AddUserManagementRequest();
    request.setEmail(email);
    request.setPassword(password);
    request.setPhoneNumber(phone);
    request.setType(type);
    request.setUser(user);
    request.setDocumentId(documentId);
    request.setNationalId(nationalId);
    request.setLicenseNo(licenceNo);
    request.setDocument(document);
    request.setClientOrgId(consignee);
    request.setVehicleIdsList(vehicleId);
    request.setDocumentExt(documentExt);
    request.setDocumentName(documentName);
    request.setOrganizationId(organizationId)

    function dispatcher() {
      dispatchUsers(dispatch, selectedTab);
    }

    dispatch(
      apiResponse<
        UserManagementServiceClient,
        AddUserManagementRequest,
        AddUserManagementResponse
      >({
        client: userManagementServiceClient,
        action: "addUser",
        request,
        dispatcher,
        successMessage: SUCCESS_MESSAGES.addUser,
        modalAction: true,
      })
    );
  };
}

export function fetchAllUsers() {
  return (dispatch: Dispatch<any>, getState: GetState) => {
    const { allUsersPage, search } = getState().users;
    const {userType} = getState().common

    const page = new PageRequest();
    page.setPageNumber(allUsersPage.selectedPage);
    page.setPageSize(PAGE_SIZE);

    const request = new ListUsersManagementRequest();
   // request.setClientOrgId(CLIENT_CONSIGNEE_ID);
    if (userType == 7) {
      console.log("here it is : ", userType)
      request.setTypeList([3, 5, 7]);
    } else if (userType == 8) {
      request.setTypeList([6, 7]);
    } else if (userType == 6) {
      request.setTypeList([6]);
    } else {
      request.setTypeList([1, 2, 3, 4, 5, 6, 7, 8]);
    }

    request.setPage(page);
    var filterItem = new UserListingFilter()
    const searchFilter =   filterItem.setSearchString(search || "")
    request.setFilter(searchFilter)
    console.log("request : ", request.toObject())

    function dispatcher(resp: ListUsersManagementResponse) {
      const page = resp?.getPage()?.toObject() || {
        totalElements: 0,
        totalPages: 0,
      };
      const users = resp?.getUsersList()?.map(
        (user) =>
          ({
            ...user?.getBasic()?.toObject(),
            vehicle: user?.getAssignedvehiclesList().map((v) => v.toObject()),
          } as UserDataItem)
      );
      console.log("users in usermanagements : ", users)
      dispatch(setAllUsersTotalPage(page));
      dispatch(setAllUser(users));
    }

    dispatch(
      apiResponse<
        UserManagementServiceClient,
        ListUsersManagementRequest,
        ListUsersManagementResponse
      >({
        client: userManagementServiceClient,
        action: "listUsers",
        request,
        dispatcher,
      })
    );
  };
}

export function fetchRiderUsers() {
  return (dispatch: Dispatch<any>, getState: GetState) => {
    const { riderUsersPage, search } = getState().users;

    const page = new PageRequest();
    page.setPageNumber(riderUsersPage.selectedPage);
    page.setPageSize(PAGE_SIZE);

    const request = new ListUsersManagementRequest();
    request.setClientOrgId(CLIENT_CONSIGNEE_ID);
    request.setTypeList([3]);
    request.setPage(page);
    var filterItem = new UserListingFilter()
    const searchFilter =   filterItem.setSearchString(search || "")
    request.setFilter(searchFilter)
    function dispatcher(resp: ListUsersManagementResponse) {
      const page = resp?.getPage()?.toObject() || {
        totalElements: 0,
        totalPages: 0,
      };
      const users = resp?.getUsersList()?.map(
        (user) =>
          ({
            ...user?.getBasic()?.toObject(),
            vehicle: user?.getAssignedvehiclesList().map((v) => v.toObject()),
          } as UserDataItem)
      );

      dispatch(setRiderUsersTotalPage(page));
      dispatch(setRiderUser(users));
    }

    dispatch(
      apiResponse<
        UserManagementServiceClient,
        ListUsersManagementRequest,
        ListUsersManagementResponse
      >({
        client: userManagementServiceClient,
        action: "listUsers",
        request,
        dispatcher,
      })
    );
  };
}

export function fetchOperatorUsers() {
  return (dispatch: Dispatch<any>, getState: GetState) => {
    const { riderUsersPage, search } = getState().users;

    const page = new PageRequest();
    page.setPageNumber(riderUsersPage.selectedPage);
    page.setPageSize(PAGE_SIZE);
    const request = new ListUsersManagementRequest();
    request.setClientOrgId(CLIENT_CONSIGNEE_ID);
    request.setTypeList([6]);
    request.setPage(page);
    var filterItem = new UserListingFilter()
    const searchFilter =   filterItem.setSearchString(search || "")
    request.setFilter(searchFilter)
    function dispatcher(resp: ListUsersManagementResponse) {
      const page = resp?.getPage()?.toObject() || {
        totalElements: 0,
        totalPages: 0,
      };
      const users = resp?.getUsersList()?.map(
          (user) =>
              ({
                ...user?.getBasic()?.toObject(),
                vehicle: user?.getAssignedvehiclesList().map((v) => v.toObject()),
              } as UserDataItem)
      );

      dispatch(setAllUsersTotalPage(page));
      dispatch(setAllUser(users));
    }

    dispatch(
        apiResponse<
            UserManagementServiceClient,
            ListUsersManagementRequest,
            ListUsersManagementResponse
        >({
          client: userManagementServiceClient,
          action: "listUsers",
          request,
          dispatcher,
        })
    );
  };
}

export function fetchUsersByType(type=0) {
  return (dispatch: Dispatch<any>, getState: GetState) => {
    const { riderUsersPage, search } = getState().users;

    const page = new PageRequest();
    page.setPageNumber(riderUsersPage.selectedPage);
    page.setPageSize(PAGE_SIZE);
    const request = new ListUsersManagementRequest();
    request.setClientOrgId(CLIENT_CONSIGNEE_ID);
    if (type > 0) {
      request.setTypeList([type]);
    }

    request.setPage(page);
    var filterItem = new UserListingFilter()
    const searchFilter =   filterItem.setSearchString(search || "")
    request.setFilter(searchFilter)
    function dispatcher(resp: ListUsersManagementResponse) {
      const page = resp?.getPage()?.toObject() || {
        totalElements: 0,
        totalPages: 0,
      };
      const users = resp?.getUsersList()?.map(
          (user) =>
              ({
                ...user?.getBasic()?.toObject(),
                vehicle: user?.getAssignedvehiclesList().map((v) => v.toObject()),
              } as UserDataItem)
      );
      console.log("total page in CM : ", page)
      dispatch(setAllUsersTotalPage(page));
      dispatch(setAllUser(users));
    }

    dispatch(
        apiResponse<
            UserManagementServiceClient,
            ListUsersManagementRequest,
            ListUsersManagementResponse
        >({
          client: userManagementServiceClient,
          action: "listUsers",
          request,
          dispatcher,
        })
    );
  };
}

export function fetchAdminUsers() {
  return (dispatch: Dispatch<any>, getState: GetState) => {
    const { adminUsersPage, search } = getState().users;

    const page = new PageRequest();
    page.setPageNumber(adminUsersPage.selectedPage);
    page.setPageSize(PAGE_SIZE);

    const request = new ListUsersManagementRequest();
    request.setClientOrgId(CLIENT_CONSIGNEE_ID);
    request.setTypeList([1, 2]);
    request.setPage(page);
    var filterItem = new UserListingFilter()
    const searchFilter =   filterItem.setSearchString(search || "")
    request.setFilter(searchFilter)
    function dispatcher(resp: ListUsersManagementResponse) {
      const page = resp?.getPage()?.toObject() || {
        totalElements: 0,
        totalPages: 0,
      };
      const users = resp?.getUsersList()?.map(
        (user) =>
          ({
            ...user?.getBasic()?.toObject(),
            vehicle: user?.getAssignedvehiclesList().map((v) => v.toObject()),
          } as UserDataItem)
      );

      dispatch(setAdminUsersTotalPage(page));
      dispatch(setAdminUser(users));
    }

    dispatch(
      apiResponse<
        UserManagementServiceClient,
        ListUsersManagementRequest,
        ListUsersManagementResponse
      >({
        client: userManagementServiceClient,
        action: "listUsers",
        request,
        dispatcher,
      })
    );
  };
}

export function fetchClientAdminUsers() {
  return (dispatch: Dispatch<any>, getState: GetState) => {
    const { adminUsersPage, search } = getState().users;

    const page = new PageRequest();
    page.setPageNumber(adminUsersPage.selectedPage);
    page.setPageSize(PAGE_SIZE);

    const request = new ListUsersManagementRequest();
    request.setClientOrgId(CLIENT_CONSIGNEE_ID);
    request.setTypeList([5]);
    request.setPage(page);
    var filterItem = new UserListingFilter()
    const searchFilter =   filterItem.setSearchString(search || "")
    request.setFilter(searchFilter)
    function dispatcher(resp: ListUsersManagementResponse) {
      const page = resp?.getPage()?.toObject() || {
        totalElements: 0,
        totalPages: 0,
      };
      const users = resp?.getUsersList()?.map(
          (user) =>
              ({
                ...user?.getBasic()?.toObject(),
                vehicle: user?.getAssignedvehiclesList().map((v) => v.toObject()),
              } as UserDataItem)
      );
      console.log("client admin : ", users)
      dispatch(setAdminUsersTotalPage(page));
      dispatch(setAdminUser(users));
    }

    dispatch(
        apiResponse<
            UserManagementServiceClient,
            ListUsersManagementRequest,
            ListUsersManagementResponse
        >({
          client: userManagementServiceClient,
          action: "listUsers",
          request,
          dispatcher,
        })
    );
  };
}

export function fetchMechanicUsers() {
  return (dispatch: Dispatch<any>, getState: GetState) => {
    const { mechanicUsersPage } = getState().users;

    const page = new PageRequest();
    page.setPageNumber(mechanicUsersPage.selectedPage);
    page.setPageSize(PAGE_SIZE);

    const request = new ListUsersManagementRequest();
    request.setClientOrgId(CLIENT_CONSIGNEE_ID);
    request.setTypeList([4]);
    request.setPage(page);

    function dispatcher(resp: ListUsersManagementResponse) {
      const page = resp?.getPage()?.toObject() || {
        totalElements: 0,
        totalPages: 0,
      };
      const users = resp?.getUsersList()?.map(
        (user) =>
          ({
            ...user?.getBasic()?.toObject(),
            vehicle: user?.getAssignedvehiclesList().map((v) => v.toObject()),
          } as UserDataItem)
      );

      dispatch(setMechanicUsersTotalPage(page));
      dispatch(setMechanicUser(users));
    }

    dispatch(
      apiResponse<
        UserManagementServiceClient,
        ListUsersManagementRequest,
        ListUsersManagementResponse
      >({
        client: userManagementServiceClient,
        action: "listUsers",
        request,
        dispatcher,
      })
    );
  };
}

export function getDropdownUsers() {
  return (dispatch: Dispatch<any>) => {
    const typeFilter = new Filters.In();
    typeFilter.setIntsList([0, 1, 2, 3, 4, 5]);

    const filters = new Filter();
    filters.setType(typeFilter);

    const request = new ListUsersRiderManagementRequest();
    request.setFilter(filters);
    function dispatcher(resp: ListUsersRiderManagementResponse) {
      const users = resp
        ?.getUsersList()
        ?.map((user) => user?.getBasic()?.toObject() as UserDataItem);
      dispatch(setDropdownUsers(users));
    }

    dispatch(
      apiResponse<
        UserManagementServiceClient,
        ListUsersRiderManagementRequest,
        ListUsersRiderManagementResponse
      >({
        client: userManagementServiceClient,
        request,
        action: "listUserRiders",
        dispatcher,
      })
    );
  };
}

export function getDropdownUsersByClientID(clientID="") {
  return (dispatch: Dispatch<any>) => {
    // const typeFilter = new Filters.In();
    // typeFilter.setIntsList([0, 1, 2, 3, 4, 5]);

    // const filters = new Filter();
    // filters.setType(typeFilter);

    const request = new ListUsersRiderManagementRequest();
    //request.setFilter(filters);
    request.setOwnerOrgId(clientID)
    console.log("request id : ", request.getOwnerOrgId())
    console.log("request : ", request)
    function dispatcher(resp: ListUsersRiderManagementResponse) {
      const users = resp
          ?.getUsersList()
          ?.map((user) => user?.getBasic()?.toObject() as UserDataItem);
      console.log("users list : ", users)
      dispatch(setDropdownUsers(users));
    }

    dispatch(
        apiResponse<
            UserManagementServiceClient,
            ListUsersRiderManagementRequest,
            ListUsersRiderManagementResponse
        >({
          client: userManagementServiceClient,
          request,
          action: "listUserRiders",
          dispatcher,
          ownerOrgId:clientID,
        })
    );
  };
}

export function getAllDropdownUsers() {
  return (dispatch: Dispatch<any>) => {
    const typeFilter = new Filters.In();
    typeFilter.setIntsList([0, 1, 2, 3, 4, 5]);

    const request = new ListUsersManagementRequest();
    const page = new PageRequest();
    page.setPageNumber(1);
    page.setPageSize(10000);
    request.setPage(page);
    request.setTypeList([0, 1, 2, 3, 4, 5]);

    function dispatcher(resp: ListUsersManagementResponse) {
      const users = resp
          ?.getUsersList()
          ?.map((user) => user?.getBasic()?.toObject() as UserDataItem);
      dispatch(setDropdownUsers(users));
    }

    dispatch(
        apiResponse<
            UserManagementServiceClient,
            ListUsersManagementRequest,
            ListUsersManagementResponse
        >({
          client: userManagementServiceClient,
          request,
          action: "listUsers",
          dispatcher,
        })
    );
  };
}

export function getRiderStats(user_phone: string) {
  return (dispatch: Dispatch<any>) => {
    
    const request = new GetUserStatsRequest();
    request.setUserPhone(user_phone)
    

    function dispatcher(resp: GetUserStatsResponse) {
      const stats = resp
        ?.getStat()?.toObject();
        console.log("Rider Stats : ", stats)
      dispatch(setRiderStats(stats));
    }

    dispatch(
      apiResponse<
        UserStatsServiceClient,
        GetUserStatsRequest,
        GetUserStatsResponse
      >({
        client: userStatsServiceClient,
        request,
        action: "getUserStats",
        dispatcher,
      })
    );
  };
}

export function getFeedbackStats() {
  return (dispatch: Dispatch<any>) => {
    
    const request = new GetUsersFeedbackStatsRequest();

    function dispatcher(resp: GetUsersFeedbackStatsResponse) {
      const stats = resp
        ?.toObject();
        console.log("FeedbackStats Stats : ", stats)
      dispatch(setFeedbackStats(stats));
    }

    dispatch(
      apiResponse<
        UserServiceClient,
        GetUsersFeedbackStatsRequest,
        GetUsersFeedbackStatsResponse
      >({
        client: userServiceClient,
        request,
        action: "getUsersFeedbackStats",
        dispatcher,
      })
    );
  };
}

export function getRiderScoreGroups({
  start_date,
  end_date,
  organization_id,
}: {
  start_date: string;
  end_date: string;
  organization_id: string;
}) {
  const isValidStartDate = dayjs(start_date, 'YYYY-MM-DD', true).isValid();
  const isValidEndDate = dayjs(end_date, 'YYYY-MM-DD', true).isValid();

  const validStartDate = isValidStartDate ? start_date : dayjs().format('YYYY-MM-DD');
  const validEndDate = isValidEndDate ? end_date : dayjs().format('YYYY-MM-DD');


  const request = new GetRiderScoreGroupsRequest();
  request.setStartDate(validStartDate || "");
  request.setEndDate(validEndDate || "");
  request.setOrganizationId(organization_id || "");

  return async (dispatch: Dispatch<any>) => {
      function dispatcher(resp: GetRiderScoreGroupsResponse) {
        
          const riderScores = {
              bad: resp.getBad(),
              average: resp.getAverage(),
              good: resp.getGood(),
          };

          console.log("Rider Score Groups:--------------------------------- ", riderScores);
          dispatch(setRiderScoreGroups(riderScores));
      }

      dispatch(
          apiResponse<
          UserStatsServiceClient,
              GetRiderScoreGroupsRequest,
              GetRiderScoreGroupsResponse
          >({
              client: userStatsServiceClient,
              action: "getRiderScoreGroups",
              request,
            //  errorMessage: "No rider score data found for the selected date range",
              dispatcher,
          })
      );
  };
}


export function getRiderScoreListByAvgScore({
  start_date,
  end_date,
  organization_id,
  min_score,
  max_score,
}: {
  start_date: string;
  end_date: string;
  organization_id: string;
  min_score: number;
  max_score: number;
}) {
  const isValidStartDate = dayjs(start_date, 'YYYY-MM-DD', true).isValid();
  const isValidEndDate = dayjs(end_date, 'YYYY-MM-DD', true).isValid();

  const validStartDate = isValidStartDate ? start_date : dayjs().format('YYYY-MM-DD');
  const validEndDate = isValidEndDate ? end_date : dayjs().format('YYYY-MM-DD');

  console.log("Organization ID: ", organization_id);
  console.log("Start Date: ", validStartDate);
  console.log("End Date: ", validEndDate);
  console.log("Min Score: ", min_score);
  console.log("Max Score: ", max_score);

  const request = new GetRiderScoreListByAvgScoreRequest();
  request.setStartDate(validStartDate || "");
  request.setEndDate(validEndDate || "");
 // request.setOrganizationId(organization_id || "");
 request.setMinScoreAvg(min_score || 0);
 request.setMaxScoreAvg(max_score || 0);

  return async (dispatch: Dispatch<any>) => {
      function dispatcher(resp: GetRiderScoreListByAvgScoreResponse ) {
        
          const riderList = {response: resp?.getRiderListList()}

          console.log("Rider Summary List:--------------------------------- ", riderList.response);
          dispatch(setRiderSummary(riderList.response));
      }

      dispatch(
          apiResponse<
          UserStatsServiceClient,
          GetRiderScoreListByAvgScoreRequest ,
          GetRiderScoreListByAvgScoreResponse  
          >({
              client: userStatsServiceClient,
              action: "getRiderScoreListByAvgScore",
              request,
              errorMessage: "No rider list data found for the selected date range",
              dispatcher,
          })
      );
  };
}

export function dispatchUsers(dispatch: Dispatch<any>, tabName: UserTabName) {
  console.log("tabName : ")
  switch (tabName) {
    case "all":
      dispatch(fetchAllUsers());
      break;

    case "riders":
      dispatch(fetchRiderUsers());
      break;

    // case "mechanics":
    //   dispatch(fetchMechanicUsers());
    //   break;
    case "admins":
      dispatch(fetchAdminUsers());
      break;

    case "client admins":
      dispatch(fetchClientAdminUsers());
      break;
    case "operations monitor":
      dispatch(fetchOperatorUsers());
      break;
    case "customer manager":
      dispatch(fetchUsersByType(7));
      break;
    case "production manager":
      dispatch(fetchUsersByType(8));
      break;
    default:
      dispatch(fetchAllUsers());
      break;
  }
}

export function deleteUser(userId: string, isBlock = false) {
  return (dispatch: Dispatch<any>, getState: GetState) => {
    const { selectedTab } = getState().users;

    const request = new DeleteUserAdminRequest();
    request.setId(userId);

    function dispatcher() {
      dispatchUsers(dispatch, selectedTab);
    }

    dispatch(
      apiResponse<
        UserAdminServiceClient,
        DeleteUserAdminRequest,
        DeleteUserAdminResponse
      >({
        client: userAdminServiceClient,
        action: "deleteUser",
        request,
        dispatcher,
        successMessage: isBlock
          ? SUCCESS_MESSAGES.blockAccount
          : SUCCESS_MESSAGES.deleteUser,
      })
    );
  };
}

export function updateUser(
  {
    email,
    firstName,
    lastName = "",
    number,
    type,
    documentId,
    nationalId,
    licenceNo,
    vehicleId,
    document,
    documentExt,
    documentName,
      organizationId,
  }: Omit<UserPayload, "password" | "countryPrefix">,
  userId: string
) {
  return (dispatch: Dispatch<any>, getState: GetState) => {
    const {
      users: { selectedTab },
    } = getState();

    const user = new UserDataUpdate();
    user.setFirstName(firstName);
    user.setLastName(lastName);
    user.setEmail(email);
    user.setType(type);
    user.setDocumentId(documentId);
    user.setNationalId(nationalId);
    user.setLicenseNo(licenceNo);
    user.setPhoneNumber(number);
    user.setVehicleIdsList(vehicleId);
    user.setDocument(document);
    user.setDocumentExt(documentExt);
    user.setDocumentName(documentName);

    const request = new UpdateUserManagementRequest();
    request.setId(userId);
    request.setUser(user);

    function dispatcher() {
      dispatchUsers(dispatch, selectedTab);
      dispatch(getUpdatedUser(userId));
    }

    dispatch(
      apiResponse<
        UserManagementServiceClient,
        UpdateUserManagementRequest,
        UpdateUserManagementResponse
      >({
        client: userManagementServiceClient,
        action: "updateUser",
        request,
        successMessage: SUCCESS_MESSAGES.updateUser,
        dispatcher,
        modalAction: true,
      })
    );
  };
}

export function getUpdatedUser(userId: string) {
  return (dispatch: Dispatch<any>) => {
    const request = new GetUserManagementRequest();
    request.setId(userId);

    function dispatcher(resp: GetUserManagementResponse) {
      const user = resp.getUser()?.getBasic();
      dispatch(
        setSelectedUser({
          email: user?.getEmail() || "",
          id: user?.getId() || "",
          imgUrl: user?.getProfilePhotoLink() || "",
          name: getFullName(
            user?.getFirstName() || "",
            user?.getLastName() || ""
          ),
          phone: user?.getPhoneNumber() || "",
          type: user?.getType() || 1,
          documentId: user?.getDocumentId(),
          nationalId: user?.getNationalId(),
          lincenceNo: user?.getLicenseNo(),
          vehicle: resp?.getAssignedVehicleList().map((v) => v.toObject()),
          document: user?.getDocument(),
          documentLink: user?.getDocumentLink(),
          documentName: user?.getDocumentName(),
          documentType: user?.getDocumentExt(),
          organization_id:user?.getOrganizationId() || "",
          organization_name: user?.getOrganizationName() || "Zyp",
          user_business_type: user?.getUserbusinesstype(),
        })
      );
    }

    dispatch(
      apiResponse<
        UserManagementServiceClient,
        GetUserManagementRequest,
        GetUserManagementResponse
      >({
        client: userManagementServiceClient,
        request,
        action: "getUser",
        dispatcher,
      })
    );
  };
}

export function getDownloadedBytes(
  fileLink: string,
  dispatcher: (resp: DownloadFileResponse) => void
) {
  return (dispatch: Dispatch<any>) => {
    const request = new DownloadFileRequest();
    request.setFileName(fileLink);

    dispatch(
      apiResponse<
        UserManagementServiceClient,
        DownloadFileRequest,
        DownloadFileResponse
      >({
        request,
        client: userManagementServiceClient,
        dispatcher,
        action: "downloadFile",
      })
    );
  };
}

export function uploadProfilePic(
  userId: string,
  photo: string | Uint8Array,
  photoExt: string,
  photoName: string
) {
  return (dispatch: Dispatch<any>) => {
    const request = new UploadPhotoRequest();
    request.setUserId(userId);
    request.setPhoto(photo);
    request.setPhotoExt(photoExt);
    request.setPhotoName(photoName);

    dispatch(
      apiResponse<
        UserManagementServiceClient,
        UploadPhotoRequest,
        UploadPhotoResponse
      >({
        request,
        action: "uploadProfilePhoto",
        dispatcher: () => {
          dispatch(getUpdatedUser(userId));
        },
        client: userManagementServiceClient,
      })
    );
  };
}
